export enum ServiceType {
  AutoFollow = 1,
  Recommendations = 2,
}

export const serviceTypeLabels: Record<ServiceType, string> = {
  [ServiceType.AutoFollow]: 'Автоследование',
  [ServiceType.Recommendations]: 'Автоконсультирование',
};

export enum ClientCondition {
  AllClients = 0,
  NewClients = 1,
  FirstSubscription = 2,
  WasSubscribed = 3,
  Unattached = 4,
  Attached = 5,
}

export const clientConditionLabels: Record<ClientCondition, string> = {
  [ClientCondition.AllClients]: 'Все клиенты',
  [ClientCondition.NewClients]: 'Клиенты, подключающиеся в первый раз',
  [ClientCondition.FirstSubscription]: 'Клиенты, подключающиеся первый раз на этот счет',
  [ClientCondition.WasSubscribed]: 'Бывшие клиенты',
  [ClientCondition.Unattached]: 'Все подключающиеся клиенты',
  [ClientCondition.Attached]: 'Подключенные клиенты',
};

export const conditionsWithExtraDays: ClientCondition[] = [
  ClientCondition.WasSubscribed,
  ClientCondition.Unattached,
  ClientCondition.Attached,
];

export type Promotion = {
  id: number;
  name: string;
  active: boolean;
  startDate: string;
  endDate: string;
  returnDate: string | null;
  limitTime: number | null;
  serviceType: ServiceType;
  clientConditions: ClientCondition;
  clientConditionsDays: number | null;
  strategyIds: string[];
  tariffId: string;
  tariffDisplayValue: string;
  tariffDescription: string;
  tariffInfo: string;
  clients?: number;
};

export type PromotionRequest = {
  id?: number;
  name: string;
  startDate: string;
  endDate: string;
  returnDate: string | null;
  limitTime: number | null;
  clientConditionsDays: number | null;
  serviceType: ServiceType;
  clientConditions: ClientCondition;
  strategyIds: string[];
  tariffId: string;
  tariffDisplayValue: string;
  tariffDescription: string;
  tariffInfo: string;
};

export type PromotionFormData = {
  name: string;
  serviceType: string;
  clientConditions: string;
  clientConditionsDays: number | null;
  strategyIds: string[];
  tariffId: string;
  tariffDisplayValue: string;
  tariffDescription: string;
  tariffInfo: string;
  startDate: string | null;
  endDate: string | null;
  returnDate: string | null;
  limitTime: number | null;
};
